<template>
  <div>
    <v-dialog
      v-model="realogramDetailsModal"
      width="1200"
      scrollable
      persistent
    >
      <v-card class="popup add_store_popup realogram">
        <v-card-title class="d-flex justify-space-between align-center mb-4">
          <div class="page-title-bar mb-0">
            <img
              src="@/assets/img/camera.png"
              style="margin-right: 10px; width: 30px"
            />
            {{ $t("Realogram Details") }}
          </div>
          <div class="modal-header-right">
          <v-chip small class="info-chip mr-2">
            {{ $t('Shelf') }}: {{ shelfItem.shelfId }}
          </v-chip>
          <v-chip small class="info-chip">
            {{ $t("Section") }}: {{ shelfItem.section }}
          </v-chip>
          <v-chip small class="info-chip">
            {{ $t("Floor") }}: {{ shelfItem.floor }}
          </v-chip>
        </div>
        </v-card-title>
        <v-card-text class="content">
          <v-row>
            <v-col cols="3" class="fill-height pb-0">
              <v-data-table
                v-model="selectedCaptureTime"
                :headers="captureTimeHeader"
                :items="captureTimeItems"
                :hide-default-footer="true"
                class="tbl-type01 products flex-grow-1 fill-height"
                height="100%"
                fixed-header
                :item-class="getCaptureRowClass"
                @click:row="handleCaptureRowClick"
                single-select
                item-key="captureTime"
              >
              </v-data-table>
            </v-col>
            <v-col cols="4" class="fill-height pb-0">
                <v-data-table
                v-model="selectedProduct"
                :headers="productHeader"
                :items="productItems"
                :hide-default-footer="true"
                :items-per-page="-1"
                class="tbl-type01 products flex-grow-1 fill-height"
                height="100%"
                fixed-header
                :item-class="getProductRowClass"
                @click:row="handleProductRowClick"
                item-key="clusterId"
                single-select
              >
                <template #[`item.no`]="{ item }">
                  {{ productItems.indexOf(item) + 1 }}
                </template>
                <template #[`item.article_name`]="{ item }">
                  {{ item.productInfo[0].article_name || '-' }}
                </template>
                <template #[`item.status`]="{ item }">
                  <v-chip
                    v-if="item && item.weakConnection > 0"
                    class="ma-2 ml-0"
                    color="red"
                    outlined
                    small
                  >
                    <v-icon left color="red"> mdi-information </v-icon>
                    {{ $t("ESL might be missing") }}
                  </v-chip>
                  <v-chip
                    v-else
                    class="ma-2 ml-0"
                    color="green"
                    outlined
                    small
                  >
                    <v-icon left color="green"> mdi-check-circle </v-icon>
                    {{ $t("Completed") }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="5" class="imageSection d-flex flex-column">
              <div class="image-header">
                <div>
                  <div class="d-flex justify-space-between">
                    <v-chip
                      v-if="selectedProduct[0] && selectedProduct[0].weakConnection > 0"
                      class="ma-2 ml-0"
                      color="red"
                      outlined
                      small
                    >
                      <v-icon left color="red"> mdi-information </v-icon>
                      {{ $t("ESL might be missing") }}
                    </v-chip>
                    <v-chip v-else class="ma-2 ml-0" color="green" outlined>
                      <v-icon left color="green"> mdi-check-circle </v-icon>
                      {{ $t("Completed") }}
                    </v-chip>
                    <div @click="handleSwap">
                      <img src="@/assets/img/swap.png" alt="" />
                    </div>
                  </div>
                  <div>
                    {{ selectedProduct[0] && selectedProduct[0].productInfo[0] && selectedProduct[0].productInfo[0].article_id }} |
                    {{ selectedProduct[0] && selectedProduct[0].productInfo[0] && selectedProduct[0].productInfo[0].article_name }}
                  </div>
                </div>
              </div>
              <v-divider
                class="my-2"
                style="border: 1px solid rgb(0, 0, 0, 0.5)"
              ></v-divider>
              <div class="imgContainer flex-grow-1">
                <!-- VROG image (default) -->
                <div
                  v-show="swapImage"
                  ref="shelfImgContainer"
                  class="vrog-container"
                ></div>

                <!-- Pure canvas overlay (on swap) -->
                <div
                  v-show="!swapImage"
                  ref="canvasContainer"
                  class="vrog-container"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="ma-auto">
          <v-btn @click="handleClose()" class="btn type-search mt-5" text>
            {{ $t("Close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import codes from '@/plugins/codes'
import { mapGetters } from 'vuex'
import VROGRenderer from '@/lib/vrog-renderer.js'
import CanvasRenderer from '@/lib/canvas-renderer.js'
import commons from '@/plugins/commons'

export default {
  props: ['shelfItem', 'value'],
  data () {
    return {
      realogramDetailsModal: false,
      selectedCaptureTime: [],
      selectedProduct: [],
      captureTimeHeader: [
        {
          text: '#',
          sortable: false,
          value: 'id'
        },
        {
          text: this.$t('Capture Time'),
          align: 'center',
          sortable: false,
          value: 'captureTime'
        }
      ],
      captureTimeItems: [],
      productHeader: [
        { text: '#', align: 'center', sortable: false, value: 'no' },
        {
          text: this.$t('Product'),
          align: 'center',
          sortable: false,
          value: 'article_name'
        },
        {
          text: this.$t('Issue Status'),
          align: 'center',
          sortable: false,
          value: 'status'
        }
      ],
      productItems: [],
      shelfInfo: [],
      rogShelfInfo: null,
      swapImage: true
    }
  },
  created () {
    this._shelfImgContainer = null
    this._canvasRenderer = null
    this._lastImageUrl = null
  },
  watch: {
    value (val) {
      this.realogramDetailsModal = val
      if (val) {
        this.getDetails()
      }
    },
    // When swap toggles, init the renderer that just became visible
    async swapImage (nowVROG) {
      await this.$nextTick()
      if (nowVROG) {
        await this._initVROG(this._lastImageUrl)
      } else {
        await this._initCanvas(this._lastImageUrl)
      }
      // Re-apply current highlight to whichever renderer is now active
      const labelCode = this.selectedProduct[0]?.eslInfo?.[0]?.labelCode || ''
      this._highlightActive(labelCode)
    }
  },
  computed: {
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    })
  },
  methods: {
    handleSwap () {
      this.swapImage = !this.swapImage
    },

    handleErrorRowClick (item) {
      const labelCode = item.eslInfo?.[0]?.labelCode || ''
      this._highlightActive(labelCode)
    },

    /** Route highlight to whichever renderer is currently visible */
    _highlightActive (labelCode) {
      if (this.swapImage) {
        if (this._shelfImgContainer) this._shelfImgContainer.highlightByKey(labelCode)
      } else {
        if (this._canvasRenderer) this._canvasRenderer.highlightByKey(labelCode)
      }
    },

    // ── VROG renderer ────────────────────────────────────────────────────────
    async _initVROG (imageUrl) {
      if (this._shelfImgContainer) {
        this._shelfImgContainer.destroy()
        this._shelfImgContainer = null
      }
      if (!this.$refs.shelfImgContainer) return
      this._shelfImgContainer = new VROGRenderer(
        this.$refs.shelfImgContainer,
        imageUrl,
        this._normaliseShelfInfo(this.rogShelfInfo),
        '#FFFFFF'
      )
      await this._shelfImgContainer.render()
    },

    // ── Canvas renderer ──────────────────────────────────────────────────────
    async _initCanvas (imageUrl) {
      if (this._canvasRenderer) {
        this._canvasRenderer.destroy()
        this._canvasRenderer = null
      }
      if (!this.$refs.canvasContainer) return
      this._canvasRenderer = new CanvasRenderer(
        this.$refs.canvasContainer,
        imageUrl,
        this._normaliseShelfInfo(this.rogShelfInfo)
      )
      await this._canvasRenderer.render()
    },

    // ── Called on every capture-row click ───────────────────────────────────
    async _initRenderers (rogImageUrl) {
      this._lastImageUrl = rogImageUrl
      // Only init whichever is currently visible; the other inits on swap
      if (this.swapImage) {
        await this._initVROG(rogImageUrl)
      } else {
        await this._initCanvas(rogImageUrl)
      }
    },

    // Converts camelCase shelfInfo → snake_case for both renderers.
    // Also passes prdInfo through so CanvasRenderer can draw product boxes.
    _normaliseShelfInfo (shelfInfo) {
      return shelfInfo.map((row) =>
        row.map((cell) => ({
          ...cell,
          cluster_bbox: cell.clusterBbox,
          esl_info: (cell.eslInfo || []).map((e) => ({
            label_code: e.labelCode,
            esl_bbox: e.eslBbox
          })),
          prd_info: [
            {
              article_name: cell.productInfo[0].article_name,
              article_id: cell.productInfo[0].article_id
            }
          ],
          // Passed through so CanvasRenderer draws individual product boxes
          // prdInfo: cell.productInfo,
          status: cell.status
        }))
      )
    },

    handleClose () {
      if (this._shelfImgContainer) {
        this._shelfImgContainer.destroy()
        this._shelfImgContainer = null
      }

      if (this._canvasRenderer) {
        this._canvasRenderer.destroy()
        this._canvasRenderer = null
      }

      this.selectedCaptureTime = []
      this.selectedProduct = []
      this.captureTimeItems = []
      this.productItems = []
      this.shelfInfo = []
      this.rogShelfInfo = null
      this.swapImage = true
      this._lastImageUrl = null
      this.$emit('input', false)
    },

    handleCaptureRowClick (item) {
      this.selectedCaptureTime = [item]
      this.productItems = (item.shelfInfo || []).flatMap(
        (shelfRow) => shelfRow
      )
      this.rogShelfInfo = item.shelfInfo
      this.$nextTick(async () => {
        await this._initRenderers(item.shelfImage)
        this.handleProductRowClick(this.captureTimeItems[item.id - 1].shelfInfo[0][0])
      })
    },

    getCaptureRowClass (item) {
      return item.captureTime === this.selectedCaptureTime[0]?.captureTime
        ? 'selected-row'
        : ''
    },

    handleProductRowClick (item) {
      this.selectedProduct = [item]
      this.handleErrorRowClick(item)
    },

    getProductRowClass (item) {
      return item.clusterId === this.selectedProduct[0]?.clusterId
        ? 'selected-row'
        : ''
    },

    getDetails () {
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.store.code,
        shelfId: this.shelfItem.shelfId,
        floor: this.shelfItem.floor
      }
      const config = { params }

      this.$utils
        .callAxios(
          codes.requests.getRogDetails.method,
          codes.requests.getRogDetails.url,
          config
        )
        .then((res) => {
          if (res?.data?.rogHistoryInfoList?.length) {
            this.captureTimeItems = res.data.rogHistoryInfoList.map((item, index) => {
              return {
                id: index + 1,
                ...item,
                captureTime: item.captureTime ? commons.convertDate(item.captureTime) : '-'
              }
            })
            if (this.captureTimeItems[0]?.shelfInfo.length) {
              this.handleCaptureRowClick(this.captureTimeItems[0])
            }
          }
        })
    }
  }
}
</script>

<style scoped>
.modal-header-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.info-chip {
  background: #e8edf2 !important;
  color: #001e38 !important;
  font-weight: 600;
  font-size: 12px;
}

.realogram {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  padding-top: 0;
}

.content > .row {
  flex: 1;
  min-height: 0;
}

.imageSection {
  height: 100%;
  margin-top: 12px;
  background-color: rgb(238, 238, 238) !important;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.imgContainer {
  flex: 1;
  overflow-y: auto;
}

.shelfImgContainer {
  width: 418px;
  height: 540px;
  overflow: auto;
}

::v-deep .v-data-table thead th {
  background-color: #ececec !important;
  white-space: nowrap;
}

::v-deep .selected-row td {
  background: #09263f !important;
  color: #ffffff !important;
}

.vrog-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

::v-deep ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::v-deep ::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
::v-deep ::-webkit-scrollbar-thumb {
  background: #c5cdd6;
  border-radius: 4px;
}
::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #9aa0ac;
}
</style>
